import { Form, FormField, ModalId, useUIActions, FieldType, FileField, Spinner } from "../../../../../features/ui"
import { PaymentOrder } from '../../../state/types'
import { useState } from "react"
import { useActions } from "./actions"
import { Data2, useDataTypesHooks } from "../../../../../features/data-types"
import { fileHelpers } from '../../../../../features/files'
import { operationHelpers } from "../../../../operations"

type Props = {
    paymentOrder?: PaymentOrder
}

export const ConfirmPaymentForm = (props: Props) => {
    const { paymentOrder } = props
    
    const [receiptFile, setReceiptFile] = useState<File>()

    const { paymentReceiptFileName } = fileHelpers
    const { describeCode } = operationHelpers
    const { formatValue } = useDataTypesHooks()

    const { submitPayment } = useActions()
    const { closeModal } = useUIActions()

    if (!paymentOrder) return <Spinner />

    const fields: FormField[] = [
        {
            name: 'code',
            type: FieldType.NUMBER,
            label: 'Orden de Pago',
            render: () => <>{describeCode(paymentOrder)}</>
        },
        {
            name: 'paymentDate',
            type: FieldType.DATE,
            label: 'Fecha de Cobro',
            defaultValue: new Date(),
            max: new Date()
        },
        {
            name: 'payedAmount',
            type: FieldType.PRICE,
            label: 'Importe',
            render: () => <>{formatValue(paymentOrder.payedAmount, FieldType.PRICE)}</>
        },
        {
            name: 'receiptUrl',
            type: FieldType.FILE,
            label: 'Comprobante de Pago',
            hint: 'Formato: PDF',
            render: () => (
                <FileField
                    id="receiptUrl"
                    fileName={paymentReceiptFileName(paymentOrder.code)}
                    onChange={setReceiptFile}
                />
            )
        }
    ]
    
    const onSubmit = (data: Data2) => {
        submitPayment(paymentOrder.id, data.paymentDate! as Date, receiptFile)
    }

    const handleCancel = () => closeModal(ModalId.CONFIRM_PAYMENT_FORM)

    return (
        <Form
            formId="confirm-payment-form"
            fields={fields}
            createMode={false}
            updateLabel="Confirmar"
            onSubmit={onSubmit}
            onCancel={handleCancel}
        />
    )
}
